export default "__VITE_ASSET__D$IGsO8F__"